<template>
  <div id="terms-privacy">
    <comp-header
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious"
    ></comp-header>
    <div class="terms">
      <comp-terms-service></comp-terms-service>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompTermsService from '@/components/CompTermsService';

export default {
  name: 'terms-privacy',
  mixins: [
    common,
  ],
  data() {
    return {
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('terms.title.service'),
    };
  },
  components: {
    'comp-header': CompHeader,
    'comp-terms-service': CompTermsService,
  },
  mounted() {
    this.isShowMenu(false);
  },
};
</script>

<style lang="scss" src="../../scss/terms.scss"></style>



// WEBPACK FOOTER //
// src/views/terms/terms-service.vue